import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Errors stay until closed, can be copied, and don't stack duplicates (see utils/toastSetup)
import './utils/requestTrace';
import './utils/toastSetup';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-phone-number-input/style.css';
import { applyTextSize } from './utils/textSize';

// The text size this person chose in Settings, before anything is drawn
applyTextSize();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      {/* At most 4 at once; more wait their turn (an error's "Close all" clears them too) */}
      <ToastContainer position="bottom-right" limit={4} />
    </BrowserRouter>
  </React.StrictMode>
);












